import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App/App';

import { BrowserRouter } from 'react-router-dom';
import './style/variables.css';
import './style/index.css';
import './style/reset.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
